import React from 'react';
import { Route } from 'react-router';
import GalleryList from './GalleryList/GalleryList';
import SingleGalleryFull from './SingleGalleryFull/SingleGalleryFull';
import { Switch } from 'react-router-dom';
import { environments } from 'environments/environments';

class PhotoSection extends React.Component {
  componentDidMount(): void {
    document.title = environments.pageTitle + ' - Fotky';
  }

  render() {
    return (
      <div className="section">
        <Switch>
          <Route path="/fotky/" exact render={() => <GalleryList />} />
          <Route path="/fotky/:gid" exact component={SingleGalleryFull} />
          <Route path="/fotky/:gid/:fid" component={SingleGalleryFull} />
        </Switch>
      </div>
    );
  }
}

export default PhotoSection;